/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';
import type { IPerson } from './person-schema';
import { personSchema } from './person-schema';

export const personResponseSchema = createApiResponseSchema(
  personSchema,
) as import('zod').ZodSchema<IAPI<IPerson>>;

export type IPersonResponse = IAPI<IPerson>;
